<template>
  <FilterPopper>
    <template #default="{ menuOpen }">
      <BaseFilterButton
        :name="'Dates'"
        :active="isActive"
        :tagValue="tagValue"
        :menuOpen="menuOpen"
      />
    </template>
    <template #popper>
      <div class="filter-settings">
        <div class="filter-settings__group">
          <label for="task-start-date-filter">Start Date</label>
          <input
            id="task-start-date-filter"
            v-model="startDateValue"
            type="date"
            class="filter-input"
          >
        </div>
        <div class="filter-settings__group">
          <label for="task-end-date-filter">End Date</label>
          <input
            id="task-end-date-filter"
            v-model="endDateValue"
            type="date"
            class="filter-input"
          >
        </div>
      </div>
      <div class="filter-footer">
        <button class="button-text clear-button" @click="clearSelection">Clear Selection</button>
      </div>
    </template>
  </FilterPopper>
</template>

<script setup>
import { computed } from 'vue';
import FilterPopper from '@/components/FilterPopper.vue';
import BaseFilterButton from '@/components/BaseFilterButton.vue';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({
      startDate: '',
      endDate: '',
    }),
  },
});

const emit = defineEmits(['update:modelValue']);

const startDateValue = computed({
  get() {
    return props.modelValue?.startDate || '';
  },
  set(value) {
    emit('update:modelValue', {
      startDate: value || '',
      endDate: props.modelValue?.endDate || '',
    });
  },
});

const endDateValue = computed({
  get() {
    return props.modelValue?.endDate || '';
  },
  set(value) {
    emit('update:modelValue', {
      startDate: props.modelValue?.startDate || '',
      endDate: value || '',
    });
  },
});

const isActive = computed(() => Boolean(startDateValue.value || endDateValue.value));
const tagValue = computed(() => [startDateValue.value, endDateValue.value].filter(Boolean).length.toString());

const clearSelection = () => {
  emit('update:modelValue', { startDate: '', endDate: '' });
};
</script>

<style lang="scss" scoped>
.filter-settings {
  display: flex;
  flex-direction: column;
  padding: 8px;
  border-radius: inherit;
  gap: 10px;
  min-width: 220px;

  &__group {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  label {
    font-size: 12px;
    font-weight: 500;
    color: var(--body-text-color-secondary);
  }
}

.filter-input {
  width: 100%;
  padding: 8px 12px;
  background: white;
  border: 1px solid var(--gray-300);
  border-radius: 4px;
  font-size: 12px;
  outline: none;

  &:focus {
    border-color: var(--color-primary);
    box-shadow: 0 0 3px rgba(var(--color-primary-rgb), 0.2);
  }
}

.filter-footer {
  min-height: 38px;
  width: 100%;
  border-top: 1px solid rgba(140,140,140,0.375);
  padding: 8px;
  text-align: center;

  .clear-button {
    text-align: center;
    @include themify() {
      color: themed('color-danger');
    }

    &[disabled] {
      @include themify() {
        color: themed('color-disabled');
      }
    }
  }
}
</style>